// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.RequiredDocument = {
  requiredDocuments: [],
  requiredDocumentsFetched: false,
  requiredDocumentsFrontloadRequest: false,
};
